import Chip from "@material-ui/core/Chip";
import Autocomplete, {
  AutocompleteChangeReason,
  AutocompleteProps,
} from "@material-ui/lab/Autocomplete";
import { equals } from "ramda";
import { ChangeEvent } from "react";
const { SupervisedUserCircle, AccountCircle, AccountCircleOutlined, Help, ErrorRounded } = (window as any).MaterialIcons;
import UserGroupDataModel, { UsersQueryParams, } from "../DataModel/UsersDataService";

let DataService: UserGroupDataModel;

const { TextField, withStyles, Tooltip, CircularProgress, } = window.Material;

const styles = {
  userChip: {
    background: "rgb(162, 218, 255)",
  },
  groupChip: {
    background: "rgb(255, 208, 123)",
  },
  enabledUser: {
    display: "flex",
    position: "absolute",
    right: "6px",
    alignItems: "center",
    "& .MuiAutocomplete-endAdornment": {
      position: "relative",
      right: 0,
    },
  },
  icon: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  root: {
    "& .MuiChip-root": {
      justifyContent: "left",
      flexGrow: '1',
      '&:first-child': {
        marginLeft: "2px !important",
      },
    },
    "& .MuiChip-label": {
      flexGrow: "1",
    },
    "& .MuiTextField-root .MuiInputBase-root.MuiAutocomplete-inputRoot.MuiAutocomplete-inputRoot":
    {
      paddingTop: "6px",
      paddingRight: "60px",
      paddingBottom: "6px",
      paddingLeft: "6px",
      cursor: "default",
    },
    '& .MuiAutocomplete-inputRoot input.MuiInputBase-input.MuiAutocomplete-input': {
      paddingTop: "0px !important",
      paddingRight: "6px !important",
      paddingBottom: "0px !important",
      paddingLeft: "12px !important",
      minWidth: "30%",
      flexGrow: "1",
      height: "24px",
      margin: "2px",
      borderRadius: "12px",
      fontSize: "14px !important",
      backgroundColor: "#EFEFEF",
      "&:focus": {
        backgroundColor: "#EFEFEF",
      },
    },
    '& .MuiAutocomplete-inputRoot .MuiAutocomplete-endAdornment': {
      right: "3px"
    },
    "& .MuiAutocomplete-tag-user-enabled": {
      background: "rgb(162, 218, 255)",
    },
    "& .MuiAutocomplete-tag-user-disabled": {
      background: "rgb(218, 218, 218)",
    },
    "& .MuiAutocomplete-tag-group": {
      background: "rgb(255, 208, 123)",
    },
    "& .MuiAutocomplete-tag-deleted": {
      background: "rgb(150, 150, 150)",
    },
  },
};

type DisableClearable = Tripple;
type FreeSolo = Tripple;
type Multiple = Tripple;
type Option = { [key: string]: any };
type Tripple = boolean | undefined;

interface AuthorityProps extends AutocompleteProps<Option | null, Multiple, DisableClearable, FreeSolo> {
  classes: any;
  error: boolean | undefined;
  important: boolean | undefined;
  label: string;
  mandatory: boolean | undefined;
  multiple: Tripple;
  type: string;
  value: string | string[] | undefined;
  helperText: string;
  uniqueKey: string;
  disabled: boolean;
}

interface AuthorityState {
  inputValue: string;
  loading: boolean;
  matchDisabled: boolean;
  matchSystem: boolean;
  options: Option | Option[] | any;
  selectedAuthorities: Option | Option[] | any;
}
class Authority extends React.PureComponent<AuthorityProps, AuthorityState> {
  constructor(props: AuthorityProps) {
    super(props);

    DataService = new UserGroupDataModel();

    this.state = {
      inputValue: "",
      loading: true,
      matchDisabled: false,
      matchSystem: false,
      options: [],
      selectedAuthorities: [],
    };
  }

  delayTimer: any;
  
  componentDidMount = () => {
    this.getOptions();
  };

  getOptions = (queryParamsOverride: UsersQueryParams = {}) => {
    const queryParams: UsersQueryParams = {
      ...{
        filter: this.state.inputValue,
        matchDisabled: this.state.matchDisabled,
        matchSystem: this.state.matchSystem,
        maxItems: 20,
        searchBy: "DISPLAYNAME",
        uniqueKey: this.props.uniqueKey,
      }, ...queryParamsOverride
    };
    
    (async () => {
      const usersObjects:any = await DataService.getUserOptions(this.props.value, queryParams);
      const selectedOptions:Option[] = usersObjects ? usersObjects[0].sort(DataService.sortByTypeByName) : [];
      let options:Option[] = usersObjects ? usersObjects[1].sort(DataService.sortByTypeByName) : [];
      options = options.concat(selectedOptions);
      this.setState(
        (state) => (
          {
          ...state,
          selectedAuthorities: selectedOptions,
          options,
          loading: false,
          }
        )
      );
    })();
  };

  handleOnChange = (event: ChangeEvent<{}>, value: Option[] | null, action: AutocompleteChangeReason) => {
    this.props?.onChange && this.props.onChange(event, value, action);
    this.setState({ inputValue: "" });
  };

  onInputChange = async (event: ChangeEvent) => {
    event.preventDefault();
    const { value } = event.target as HTMLInputElement;
    await this.setState((state) => { return {...state, inputValue: value ?? "" }});
    this.getOptions();
  };

  componentDidUpdate = (prevProps: AuthorityProps, prevState: AuthorityState) => {
    if (!equals(prevProps.value, this.props.value)) {
      this.getOptions();
    } else if (this.state.matchDisabled !== prevState.matchDisabled) {
      this.getOptions();
    }
  };

  static defaultProps = {
    multiple: false,
  };

  toggleDisabled = (event: React.MouseEvent) => {
    event?.preventDefault();
    this.setState({ matchDisabled: !this.state.matchDisabled });
  };

  /**
   * Render tags of authority
   */
  renderTags = (value: any, getBuiltInPropsForCustomTag: Function) => {
    return value.map((item: any, index: number) => {
      const { type, enabled, deleted, system, displayName } = item;
      const uKeys = ["USER", "cm:person"];
      const gKeys = ["GROUP", "cm:authorityContainer"];

      let icon: any;
      let style: any;

      if (item === null) {
        console.error("The tag/autority is null");
      }

      switch (true) {
        case (uKeys.includes(type) && enabled === true): {
          icon = <AccountCircle />; style = "MuiAutocomplete-tag-user-enabled"; break;
        }
        case (uKeys.includes(type) && enabled === false): {
          icon = <AccountCircle />; style = "MuiAutocomplete-tag-user-disabled"; break;
        }
        case (gKeys.includes(type)): {
          icon = <SupervisedUserCircle />; style = "MuiAutocomplete-tag-group"; break;
        }
        case (deleted === true): {
          icon = <ErrorRounded />; style = "MuiAutocomplete-tag-deleted"; break;
        }
        case (type === "ZZNOTFOUND"): {
          icon = <Help />; style = "MuiAutocomplete-tag-zznotfound"; break;
        }
      }

      return (
        <Chip
          className={`MuiAutocomplete-tag ${style}`}
          classes={{ root: style }}
          key={item?.value}
          avatar={icon}
          label={item?.displayName}
          size="small"
          {...getBuiltInPropsForCustomTag({ index })}
        />
      );
    });
  };

  getGroups = (option: any) => {
    const uKeys = ["USER", "cm:person", 'cm:authority'];
    return uKeys.includes(option.type) ? window.Alfresco.messages.global["edocat.global.users"] : option.type !== "ZZNOTFOUND" ? window.Alfresco.messages.global["edocat.global.groups"] : window.Alfresco.messages.global["edocat.global.notFound"];
  }

  render() {
    const { classes, multiple, type, disabled } = this.props;
    return (
      <Autocomplete
      options={this.state.options}
      value={this.state?.selectedAuthorities || []}
      inputValue={this.state.inputValue.length > 0 ? this.state.inputValue : ""}
      className={classes?.root}
      multiple={multiple}
      groupBy={this.getGroups}
      onChange={this.handleOnChange}
      popupIcon={""}
      size="small"
      fullWidth
      id="tags-outlined"
      getOptionSelected={(option, value) => {
        return option[this.props.uniqueKey] === value[this.props.uniqueKey];
      }}
      getOptionLabel={(option) => (`${option?.displayName}`)}
      renderTags={this.props.multiple ? this.renderTags : undefined}
      disabled={disabled}
      filterSelectedOptions
      ChipProps={{ icon: <AccountCircle /> }}


        renderInput={(params: any) => {

          return (
            <TextField
              disabled={params.disabled}
              fullWidth={params.fullWidth}
              id={params.id}
              placeholder={window.Alfresco.messages.global["edocat.global.search"]}
              inputProps={

                {
                  ...params.inputProps,

                }
              }
              label={this.props?.label ?? ""}
              variant={"outlined"}
              required={this.props?.mandatory}
              error={!!this.props?.error}
              helperText={
                this.props?.error ||
                this.props?.important ||
                this.props?.helperText
              }
              InputLabelProps={{ shrink: true }}
              onChange={this.onInputChange}
              onKeyDown={(event: any) => {
                if (event.key === 'Backspace') {
                  event.stopPropagation();
                }
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <div className={classes.enabledUser}>
                    {this.state.loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                    {(type === "USER" ||
                      type === "cm:person" ||
                      type === "cm:authority") && (
                        <React.Fragment>
                          {!this.state.matchDisabled && (
                            <Tooltip
                              title={
                                window.Alfresco.messages.global[
                                "edocat.authority-inactive"
                                ]
                              }
                              placement="top"
                            >
                              <AccountCircle
                                color={
                                  this.props.disabled ? "disabled" : "primary"
                                }
                                className={classes.icon}
                                onClick={
                                  this.props.disabled ? null : this.toggleDisabled
                                }
                              />
                            </Tooltip>
                          )}
                          {this.state.matchDisabled && (
                            <Tooltip
                              title={
                                window.Alfresco.messages.global[
                                "edocat.authority-active"
                                ]
                              }
                            >
                              <AccountCircleOutlined
                                color={
                                  this.props.disabled ? "disabled" : "primary"
                                }
                                className={classes.icon}
                                onClick={
                                  this.props.disabled ? null : this.toggleDisabled
                                }
                              />
                            </Tooltip>
                          )}
                        </React.Fragment>
                      )}
                  </div>
                ),
              }}
            />
          );
        }}
      />
    );
  }
}

export default withStyles(styles)(Authority);
